import addMinutes from 'date-fns/addMinutes';

export const utcToLocal = (date: Date): Date => {
  const tzOffset = date.getTimezoneOffset();

  return addMinutes(date, -tzOffset);
};

/**
 * Formats a date as "6 Jun 2026" (en) or AR-localized equivalent.
 * Keeps tabular alignment — no zero-padding on the day.
 */
export const formatDateShort = (date: Date | string | number, locale = 'en'): string => {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '—';
  const l = locale === 'ar' ? 'ar-IQ' : 'en-GB';
  return d.toLocaleDateString(l, { day: 'numeric', month: 'short', year: 'numeric' });
};
